<template>
    <div class="container regSuccess">
        <Progress :stage="5"/>
        <div v-if="language === 'zh'" class="regSuccess-center">
            <div class="regSuccess-title">
                <img src="../assets/img/regSuccess.png" />
                恭喜您成功注册上海论坛！
            </div>
            <p class="regSuccess-content">通知邮件已发送至您的邮箱</p>
            <p class="regSuccess-content">
                您可以
                <a href="javascript:;" @click="goSummary">查看或修改注册信息</a>，
                或点击右侧链接阅览论坛会议手册、会议指南及FAQ
            </p>
            <p class="regSuccess-content" v-if="is_lecture">
                在论坛发表演讲的嘉宾，请点击
                <a href="javascript:;" @click="goDocument">上传相关与会文件</a>，
                并确保在截止日之前完成提交
            </p>
        </div>
        <div v-else>
            <div class="regSuccess-title en">
                <img src="../assets/img/regSuccess.png" />
                You have been successfully registered for Shanghai FORUM ！
            </div>
            <ul style="margin-left: 80px;">
                <li>
                    <p class="regSuccess-content">An notification email has been sent to you.</p>
                </li>
                <li v-if="charge_type === 1">
                    <p class="regSuccess-content">
                        If you need to submit an invitation letter to the embassy or consulate for your visa application, you may click
                        <a href="javascript:;" @click="openVisaModal">HERE</a>
                        or select "Visa Invitation" in the floating sidebar on the right to download it. Should the downloaded invitation letter not meet the relevant requirements, please contact us by email.
                    </p>
                </li>
                <li>
                    <p class="regSuccess-content">
                        You can
                        <a href="javascript:;" @click="goSummary">view or edit your registration information</a>,
                        or click the link on the right side of the page to find Conference Programme, Conference Guide, FAQ and to download the Invitation Letter for VISA Application.
                    </p>
                </li>
                <li v-if="is_lecture">
                    <p class="regSuccess-content">
                        Guests speakers can click to
                        <a href="javascript:;" @click="goDocument">upload relevant documents</a>.
                        Please complete the submission before the deadline.
                    </p>
                </li>
            </ul>
        </div>
        <a-modal
            id="visaDialog"
            v-model="visaModalVisible"
            :title="null"
            :footer="null"
            :closable="false"
            :centered="true"
        >
            <p class="title" style="text-align: center;font-size: 1.5em;font-weight: bold;">
              NOTICE
            </p>
            <p class="content" style="margin: 15px 0;">
                <template v-if="not_finish_information">
                    Please fill in the basic information before downloading the
                    invitation letter for VISA application.
                </template>
                <template v-else>
                    Different embassies and consulates may have different requirements for the invitation letter.
                    <span style="font-weight: bold;color: #000;">Please check the downloaded letter carefully.</span>
                    If it does not meet the requirements of the local embassy or consulate, please contact us by email (shanghaiforum@fudan.edu.cn) and we will issue a new invitation letter within two working days.
                </template>
            </p>
            <p class="footer" style="display: flex; justify-content: center;">
                <a-button @click="closeVisaModal" style="width:100px;margin-right: 20px;">Cancel</a-button>
                <a-button style="width: 100px;" type="primary" v-if="not_finish_information" @click="goInformation">OK</a-button>
                <a-button style="width: 100px;" type="primary" v-else @click="downloadVisa">Download</a-button>
            </p>
        </a-modal>
    </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import Progress from '../components/Progress';
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

  export default {
    components: {
      Progress

    },
    data () {
      return {
        form: this.$form.createForm(this),
        zhCN,
        visaModalVisible: false
      }
    },
    created() {
        this.$store.dispatch('protocol/getVisaDownLoadUrl');
    },
    mounted() {
        // 注册成功页状态设为已读
        this.$store.dispatch('main/viewSuccessPage');
        // 发送注册成功邮件
        this.$store.dispatch('main/regSuccess');
    },
    computed: {
      ...mapState({
        language: state => state.main.language,
        is_lecture: state => state.main.currentUser.is_lecture,
        charge_type: state => state.main.currentUser.charge_type,
        VISA_URL: state => state.protocol.VISA_URL
      }),
      ...mapGetters('main', {
        not_finish_information: 'not_finish_information'
      })
    },
    watch: {

    },
    methods: {
        goSummary: function () {
            if (this.language === 'zh') {
                this.$router.push('/summary');
            } else {
                this.$router.push('/en/summary');
            }
        },
        goDocument: function () {
            if (this.language === 'zh') {
                this.$router.push('/document');
            } else {
                this.$router.push('/en/document');
            }
        },
        // 打开VISA邀请函弹窗
        openVisaModal: function () {
            this.visaModalVisible = true;
        },
        // 关闭VISA提示弹窗
        closeVisaModal: function () {
            this.visaModalVisible = false;
        },
        // 补充信息
        goInformation: function () {
            this.closeVisaModal();
            this.$router.push('/en/information');
        },
        // 下载VISA邀请函
        downloadVisa: function () {
            this.closeVisaModal();
            window.open(this.VISA_URL);
        }
    }
  };
</script>

<style lang="less" scoped>
    .regSuccess {
        &-center {
            text-align: center;
        }
        img {
            width: 50px;
            height: auto;
        }
        &-title {
            margin-top: 90px;
            margin-bottom: 30px;
            font-size: 38px;
            color: #222;
            font-weight: bold;
            line-height: 40px;
            &.en {
                font-size: 28px;
            }
        }
        &-content {
            color: #999;
            font-size: 16px;
            line-height: 2;
            a {
                text-decoration: underline;
            }
        }
        li {
            list-style-type: disc;
            color: #333;
            font-size: 20px;
        }
    }
</style>
